export const validateScac = (scac: string): boolean => {
  const scacPattern = /^[A-Z0-9]{2,4}$/;

  if (scacPattern.test(scac)) {
    return true;
  }
  return false;
};
